import ReactDOM from "react-dom/client";
import React from "react";
// import App from './app'; this is wrong it should be written as below:
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
